<div [ngClass]="!isPhone ? 'entry-point' : 'entry-point-phone'">
  <div *ngIf="displayToolbar; else router">
    <app-wifi-checker></app-wifi-checker>

    <mat-drawer-container [hasBackdrop]="true" (backdropClick)="menu.close()">
      <mat-drawer #drawer [mode]="'over'">
        <div class="df jcc mt20 mb10">
          <img class="logoMenu" src="./assets/img/logos/eina_logo.png" />
        </div>
        <div class="menu-logo-line"></div>
        <app-menu
          #phoneMenu
          [drawer]="drawer"
          [isDesktop]="false"
          [ngClass]="{
            dn: !isPhone,
            'menu-shadow': menu.opened && !isPhone,
          }"
          [refService]="refService"
        >
        </app-menu>
      </mat-drawer>

      <mat-drawer-content class="main-drawer-content">
        <div [ngClass]="{ 'entry-point-contents': !isPhone }">
          <app-menu
            #menu
            [ngClass]="{
              menuDesktop: !isPhone,
              dn: isPhone,
              'menu-shadow': menu.opened && !menu.lockmenu,
              fixed: menu.lockmenu && !isPhone,
            }"
            [isDesktop]="true"
            [refService]="refService"
            (onclicktrigger)="toggleMenu(menu, phoneMenu)"
          >
          </app-menu>

          <div class="df fdc w100">
            <app-toolbar
              [mc]="menu"
              (onclick)="toggleMenu(menu, phoneMenu)"
              [showMenuButton]="isPhone"
            >
            </app-toolbar>
            <app-app-contents>
              <div [ngTemplateOutlet]="router"></div>
            </app-app-contents>
          </div>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</div>

<ng-template #router>
  <router-outlet></router-outlet>
  <!-- Confetti canvas -->
  <canvas class="confetti-canvas" id="my-canvas"></canvas>
</ng-template>

<app-developer-helper #dh>
  <mat-tab-group>
    <mat-tab label="SUBSCRIPTION">
      <ng-template matTabContent>
        <div class="subscriptions">
          <p></p>
          <!--<p class="fw600 fsm">TRIAL :</p>
                    <p class="df gap10" style="margin-left: 11px;">
                        <button mat-raised-button color="primary">
                            Trial 30 days remaining
                        </button>
                        <button mat-raised-button color="primary">
                            Trial 10 days remaining
                        </button>
                        <button mat-raised-button color="primary">
                            Trial 5 days remaining
                        </button>
                        <button mat-raised-button color="primary">
                            Trial 1 days remaining
                        </button>
                    </p>-->

          <!--<button mat-raised-button color="warn">
                        Trial end
                    </button>-->

          <!--<p></p>
                    <p class="fw600 fsm">PRO :</p>
                    <button mat-raised-button color="primary">
                        Subscribed user
                        <mat-icon class="c_y" [filled]="true">star</mat-icon>
                    </button>
                    <button mat-raised-button color="warn">
                        Pro subscription canceled
                    </button>
                    <button mat-raised-button color="warn">
                        Pro subscription ended
                    </button>-->
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="ROLE">
      <ng-template matTabContent>
        <p></p>
        <p class="fw600 c_r">ESTO CAMBIA EL ROL EN LA BASE DE DATOS</p>

        <p *ngIf="userS.hasRole(); else noRole">
          Rol actual :
          <span class="fw600">
            <span *ngIf="rIs(re.OFFICE)">OFFICE ({{ userS.getRole() }})</span>
            <span *ngIf="rIs(re.DEV)">DEVELOPER ({{ userS.getRole() }})</span>
            <span *ngIf="rIs(re.CUSTOMER_SERVICE)">CUSTOMER SERVICE ({{ userS.getRole() }})</span>
            <span *ngIf="rIs(re.COMMERCIAL)">COMERCIAL ({{ userS.getRole() }})</span>
            <span *ngIf="rIs(re.SUPER)">SUPER ({{ userS.getRole() }})</span>
          </span>
        </p>

        <ng-template #noRole>
          <p>Usuario sin rol</p>
        </ng-template>

        <div class="df gap5">
          <button
            mat-flat-button
            [color]="rIs(re.OFFICE) ? 'primary' : 'ice'"
            (click)="setRole(re.OFFICE)"
          >
            OFFICE
          </button>
          <button
            mat-flat-button
            [color]="rIs(re.DEV) ? 'primary' : 'ice'"
            (click)="setRole(re.DEV)"
          >
            DEVELOPER
          </button>
        </div>
        <p></p>
        <div class="df gap5">
          <button
            mat-flat-button
            [color]="rIs(re.CUSTOMER_SERVICE) ? 'primary' : 'ice'"
            (click)="setRole(re.CUSTOMER_SERVICE)"
          >
            CUSTOMER SERVICE
          </button>
          <button
            mat-flat-button
            [color]="rIs(re.COMMERCIAL) ? 'primary' : 'ice'"
            (click)="setRole(re.COMMERCIAL)"
          >
            COMMERCIAL
          </button>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="MODULES">
      <ng-template matTabContent>
        <p>Módulos del usuario :</p>
        <p *ngFor="let m of allModules">
          <mat-slide-toggle (change)="onChangeModule(m[1])">
            {{ m[0] }}
          </mat-slide-toggle>
        </p>
      </ng-template>
    </mat-tab>

    <!-- <mat-tab label="COMPANY">
            <mat-slide-toggle *ngIf="companyS.company" [checked]="companyS.companyMissingInfo"
                (change)="companyS.company.missing_info = !companyS.company.missing_info">
                Falta información de empresa
            </mat-slide-toggle>
        </mat-tab> -->

    <mat-tab label="FRONTEND DOCUMENTATION">
      <p>Para acceder a la documentación, escribe alguna de las siguientes palabras:</p>
      <p *ngFor="let k of keyWorkds">• {{ k }}</p>
    </mat-tab>

    <mat-tab label="I'M FROM BACKEND">
      <p>Para ver el nombre de los campos de un formulario, escribe lo siguiente:</p>
      <p>• Backend</p>
    </mat-tab>

    <mat-tab label="LOCAL STORAGE">
      <ng-template matTabContent>
        <button mat-flat-button [color]="'primary'" (click)="clearNonEssentialStorage()">
          CLEAR NON ESSENCIAL STORAGE
        </button>

        <div *ngFor="let kv of items">
          <p class="fw600 nmb">{{ kv[0] }}</p>
          <p>{{ kv[1] }}</p>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="ERRORS">
      <lib-error-viewer [er]="dh.errors"></lib-error-viewer>
    </mat-tab>
  </mat-tab-group>
</app-developer-helper>

<app-chat-internal-widget
  *ngIf="feature.chatInternal && hasPermission(perms.CHAT_INTERNAL_READ_CONVERSATIONS)"
></app-chat-internal-widget>

<!--<app-entry-point-listener></app-entry-point-listener>eastereeegg-->
